import angular from 'angular';

import { PushboxNgController } from './pushbox-ng/pushbox-ng.controller.js';
import { PushboxService } from './pushbox.services.js';

angular
  .module('pushbox', [])
  .controller('PushboxNgController', PushboxNgController)
  .factory('PushboxFactory', PushboxService.PushboxFactory);